Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    fontBold = _STYLES$useStyles.fontBold,
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    viewports = _STYLES$useStyles.viewports,
    colors = _STYLES$useStyles.colors;
  var breakpoint = bp.gt(viewports.mobile_l);
  var container = {
    display: 'flex',
    flexDirection: breakpoint ? 'row' : 'column',
    alignSelf: breakpoint ? 'flex-start' : 'center',
    justifyContent: 'center',
    alignItems: breakpoint ? 'flex-start' : 'center',
    flex: 1,
    width: '100%',
    maxWidth: breakpoint ? null : _styles.STYLES.grid.maxInputWidth
  };
  var content = {
    flex: 1,
    width: '100%',
    alignSelf: 'center'
  };
  var title = Object.assign({}, fontBold, {
    fontSize: _styles.STYLES.fontSize.xl,
    lineHeight: _styles.STYLES.lineHeight.xl,
    marginTop: spacing.m,
    marginBottom: spacing.m,
    color: colors.brand,
    alignSelf: breakpoint ? 'flex-start' : 'center',
    textAlign: breakpoint ? 'auto' : 'center'
  });
  var row = {
    alignItems: breakpoint ? 'flex-start' : 'center'
  };
  if (bp.gt(viewports.mobile_l)) {
    row.alignItems = 'flex-start';
  }
  var pill = {
    alignSelf: breakpoint ? 'flex-start' : 'center'
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    content: content,
    title: title,
    pill: pill,
    row: row
  });
  return {
    styles: styles,
    breakpoint: breakpoint
  };
};